export enum EUWDashboardTab {
  OVERVIEW = 'overview',
  REPORT_ANALYTIC = 'report-analytic',
}
